var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.getElementStyle)},[_c('p',{staticStyle:{"display":"inline","overflow":"hidden","word-wrap":"keep-all"}},[_vm._v(_vm._s(_vm.data.content))]),(_vm.isActive
    ||
    _vm.isDataTableField)?_c('span',{staticClass:"setting-icon",on:{"click":_vm.openSettings}},[_c('i',{staticClass:"el-icon-s-tools"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }